import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const searchGroceryAddresses = async ({ latitude, longitude }: { latitude: number; longitude: number }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      latitude,
      longitude,
    },
    query: graphql(`
      query SearchGroceryAddresses($latitude: Float!, $longitude: Float!) {
        searchGroceryAddresses(latitude: $latitude, longitude: $longitude) {
          id
          isActive
          email
          businessName
          apartmentNumber
          streetAddress
          postalCode
          latitude
          longitude
          distance
          instructions
          createdAt
          updatedAt
        }
      }
    `),
  });

  return response.data.searchGroceryAddresses;
};
